import React, { FunctionComponent } from "react";
import "./index.scss";
import { Space } from "../../services/entities/spaces";
import { ImageType } from "../../services/entities/content";
import EmblaCarousel from "components/EmblaCarousel";
import { Image } from "../../services/entities/content";

type SpaceDetailProps = {
  space?: Space;
};
const SpaceDetailCarousel: FunctionComponent<SpaceDetailProps> = ({
  space,
}) => {

  const bannerImages = space?.images
  ? space.images.filter((img) => img.type === ImageType.Banner)
  : null;

  return (
    <>
      {bannerImages && (
        <div className="banner-wrapper">
          <EmblaCarousel
            loop={true}
            hasDots={true}
            largeNavArrows={false}
            align={1}
            hasThumbs={false}
          >
            {(bannerImages as Image[]).map((item: Image) => {
              return (
                item && (
                  <div className="price-and-image-wrapper">
                    <div className="image-wrapper" key={item.url}>
                      <img src={item.url} alt="" />
                    </div>
                    <div className="price">
                      <p className="price-text">
                        from <br /> <span>£{space?.samplePrice?.amount}</span> a
                        day
                      </p>
                    </div>
                  </div>
                )
              );
            })}
          </EmblaCarousel>
        </div>
      )}
    </>
  );
};

export default SpaceDetailCarousel;
